__turbopack_context__.v({
  "arrowBtn": "UniversalGrid-module-scss-module__GrM_9W__arrowBtn",
  "arrows": "UniversalGrid-module-scss-module__GrM_9W__arrows",
  "backgroundMedia": "UniversalGrid-module-scss-module__GrM_9W__backgroundMedia",
  "colGap-1": "UniversalGrid-module-scss-module__GrM_9W__colGap-1",
  "colGap-2": "UniversalGrid-module-scss-module__GrM_9W__colGap-2",
  "colGap-3": "UniversalGrid-module-scss-module__GrM_9W__colGap-3",
  "colGap-4": "UniversalGrid-module-scss-module__GrM_9W__colGap-4",
  "colGap-none": "UniversalGrid-module-scss-module__GrM_9W__colGap-none",
  "container": "UniversalGrid-module-scss-module__GrM_9W__container",
  "dragging": "UniversalGrid-module-scss-module__GrM_9W__dragging",
  "grid": "UniversalGrid-module-scss-module__GrM_9W__grid",
  "hideDesktop": "UniversalGrid-module-scss-module__GrM_9W__hideDesktop",
  "hideMobile": "UniversalGrid-module-scss-module__GrM_9W__hideMobile",
  "item": "UniversalGrid-module-scss-module__GrM_9W__item",
  "maxWidth-Full": "UniversalGrid-module-scss-module__GrM_9W__maxWidth-Full",
  "maxWidth-L": "UniversalGrid-module-scss-module__GrM_9W__maxWidth-L",
  "maxWidth-M": "UniversalGrid-module-scss-module__GrM_9W__maxWidth-M",
  "maxWidth-S": "UniversalGrid-module-scss-module__GrM_9W__maxWidth-S",
  "maxWidth-XS": "UniversalGrid-module-scss-module__GrM_9W__maxWidth-XS",
  "mb-1": "UniversalGrid-module-scss-module__GrM_9W__mb-1",
  "mb-2": "UniversalGrid-module-scss-module__GrM_9W__mb-2",
  "mb-3": "UniversalGrid-module-scss-module__GrM_9W__mb-3",
  "mb-4": "UniversalGrid-module-scss-module__GrM_9W__mb-4",
  "mb-none": "UniversalGrid-module-scss-module__GrM_9W__mb-none",
  "plr-1": "UniversalGrid-module-scss-module__GrM_9W__plr-1",
  "plr-2": "UniversalGrid-module-scss-module__GrM_9W__plr-2",
  "plr-3": "UniversalGrid-module-scss-module__GrM_9W__plr-3",
  "plr-4": "UniversalGrid-module-scss-module__GrM_9W__plr-4",
  "plr-none": "UniversalGrid-module-scss-module__GrM_9W__plr-none",
  "ptb-1": "UniversalGrid-module-scss-module__GrM_9W__ptb-1",
  "ptb-2": "UniversalGrid-module-scss-module__GrM_9W__ptb-2",
  "ptb-3": "UniversalGrid-module-scss-module__GrM_9W__ptb-3",
  "ptb-4": "UniversalGrid-module-scss-module__GrM_9W__ptb-4",
  "ptb-none": "UniversalGrid-module-scss-module__GrM_9W__ptb-none",
  "rowGap-1": "UniversalGrid-module-scss-module__GrM_9W__rowGap-1",
  "rowGap-2": "UniversalGrid-module-scss-module__GrM_9W__rowGap-2",
  "rowGap-3": "UniversalGrid-module-scss-module__GrM_9W__rowGap-3",
  "rowGap-4": "UniversalGrid-module-scss-module__GrM_9W__rowGap-4",
  "rowGap-none": "UniversalGrid-module-scss-module__GrM_9W__rowGap-none",
  "section": "UniversalGrid-module-scss-module__GrM_9W__section",
  "sliderDesktop": "UniversalGrid-module-scss-module__GrM_9W__sliderDesktop",
  "sliderMobile": "UniversalGrid-module-scss-module__GrM_9W__sliderMobile",
  "sliderScrollbar": "UniversalGrid-module-scss-module__GrM_9W__sliderScrollbar",
  "snapOff": "UniversalGrid-module-scss-module__GrM_9W__snapOff",
  "vAlign-bottom": "UniversalGrid-module-scss-module__GrM_9W__vAlign-bottom",
  "vAlign-center": "UniversalGrid-module-scss-module__GrM_9W__vAlign-center",
  "vAlign-top": "UniversalGrid-module-scss-module__GrM_9W__vAlign-top",
});
